/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import styled from 'styled-components'

export default class Inline extends React.Component {
  render() {
    const { children } = this.props

    return (
      <Container>
        {children}
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0 -8px;
  
  > * {
    margin: 0;
    padding: 0 8px;
  }
`